<script>
  import Channels from './Channels/Channels.svelte';
  import Login from '../Login.svelte';
  import { Tabs, TabList, TabPanel, Tab } from '../Common/Tabs';
  import { user } from '../../Store/store';
  import { Feed } from 'tv2no-feed';
  import Feeds from './FeedChannels/Feeds.svelte';
  import Settings from './Settings/Settings.svelte';
  import { selectedChannelId } from '../../Store/feeds-store';
  import { firebaseApp } from '../../Store/store';
</script>

<div class="container">
  {#if $user}
    <div class="sidebar">
      <Channels />
    </div>
    <div class="workspace">
      {#if $selectedChannelId}
        <div class="workspace-container">
          <div class="tabs-container">
            <Tabs>
              <div class="tab-list">
                <TabList>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> rss_feed </span>
                      <span>Kanaler</span>
                    </div>
                  </Tab>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> settings </span>
                      <span>Innstillinger</span>
                    </div>
                  </Tab>
                </TabList>
              </div>
              <TabPanel>
                <Feeds />
              </TabPanel>
              <TabPanel>
                <Settings />
              </TabPanel>
            </Tabs>
          </div>
          <div class="preview-feed-container">
            <header><span>publisert</span></header>
            <div class="feed-container">
              <Feed ids={[{ id: $selectedChannelId }]} app={$firebaseApp} show="true" />
            </div>
          </div>
        </div>
      {:else}
        <div class="empty">
          <p>Velg en feed</p>
        </div>
      {/if}
    </div>
  {:else}
    <Login />
  {/if}
</div>

<style src="./messages.scss">
</style>
